import React from 'react';
import Icon from './Icon';

const EditIcon = (props) => (
    <Icon {...props}>
        <path
            d="M11 4H5A2 2 0 0 0 3 6V19A2 2 0 0 0 5 21H18A2 2 0 0 0 20 19V13M18.5 2.5A2.12 2.12 0 0 1 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default EditIcon;
